import { useAlgoliaViewAnalyticsEvent } from "@/utils/hooks/useAlgoliaViewAnalyticsEvent";
import {
  useAppDispatch,
  useAppSelector,
  useEffect,
  useRef,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import { RecipeCard } from "./RecipeCard";
import { RecipeType } from "@/utils/types/recipes";
import { useHits } from "@dxp-feed/algolia";
import { Box } from "@dxp-feed/ui/Box";
import { GLOBAL_SEARCH_RESULTS_SECTIONS } from "@/utils/constant";
import { usePathname } from "next/navigation";
import { fetchAemSearchResults } from "@/utils/redux/aem/searchData";
import NoRecipeMatched from "./NoRecipeMatched";
import { getItems } from "@/helpers/useCommonFunctions";
import { useTrendingItems } from "@/utils/hooks/useTrendingItems";

interface RecipeGridProps {
  list_name: string;
  searchQuery?: string;
  isSearchPage?: boolean;
}

export const RecipeGrid = ({
  list_name,
  isSearchPage = false,
  searchQuery = "",
}: RecipeGridProps) => {
  const { algoliaLoading } = useAppSelector((state) => state.algoliaDataSlice);
  const { items: hitsItems } = useHits() as { items: RecipeType[] };
  const { data: popularItems, isLoading: popularItemsLoading } =
    useTrendingItems(hitsItems.length === 0);
  const [items, setItems] = useState(
    getItems(searchQuery, isSearchPage, hitsItems, popularItems?.recipes?.hits)
  );
  const route = usePathname();
  const [slug, setSlug] = useState<string>("");
  const gridRef = useAlgoliaViewAnalyticsEvent(
    items,
    GLOBAL_SEARCH_RESULTS_SECTIONS.RECIPE
  );
  const dispatch = useAppDispatch();
  const { resultsPage: recipeContent, loading: isRecipeContentLoading } =
    useAppSelector((state) => state.aemStaticSearchData);

  // Fetch AEM Search Results Data when component mounts or when recipeContent changes.
  useEffect(() => {
    if (!recipeContent) {
      void dispatch(fetchAemSearchResults());
    }
  }, [dispatch, recipeContent]);

  useEffect(() => {
    setSlug(route?.split("/")[route?.split("/")?.length - 1]);
  }, [route]);
  useEffect(() => {
    setItems(
      getItems(
        searchQuery,
        isSearchPage,
        hitsItems,
        popularItems?.recipes?.hits
      )
    );
  }, [isSearchPage, searchQuery, hitsItems, popularItems]);
  const hasAddToFavRun = useRef(false);
  return (
    <Box as="div" className="w-full">
      {items?.length ? (
        <Box
          as="div"
          className={`grid ${!searchQuery && isSearchPage ? "grid-cols-1 xs:grid-cols-2  md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4" : "grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4"} gap-6`}
          ref={gridRef}
        >
          {items?.map((item: RecipeType, index: number) => (
            <RecipeCard
              isSearchPage={isSearchPage}
              key={item.objectID + index}
              item={item}
              list_name={list_name}
              searchQuery={searchQuery}
              index={index}
              hasAddToFavRun={hasAddToFavRun}
            />
          ))}
        </Box>
      ) : null}

      {!items?.length && !algoliaLoading && !popularItemsLoading && (
        <NoRecipeMatched slug={slug} recipeContent={recipeContent} />
      )}
    </Box>
  );
};
